export default "__VITE_ASSET__Dq0StEZk__"